module.exports = __webpack_public_path__ + "img/brittany.f1e5a237.jpg";